import type {
  HeroSection,
  MissionSection,
  AboutSection,
  LeverageSectionData,
  FooterSection,
} from '../pages/BrandStory';

export type HomePageSection =
  | HeroSection
  | MissionSection
  | AboutSection
  | LeverageSectionData
  | FooterSection;

export interface HomePage {
  title: string;
  description: string;
  sections: HomePageSection[];
  meta?: Record<string, any>;
  isActive?: boolean;
}

export const DEFAULT_HOME_SECTIONS: HomePageSection[] = [
  {
    type: 'hero',
    title: '<b style="display:block; font-size:0.4em; font-weight:500; letter-spacing:0.05em; margin-bottom:0.4rem;">WELCOME TO GOOD STORE</b> <b style="display:block;">好餸 - 鄰里店</b>',
    subtitle: '用每一餐的食材，陪伴 SEN青年走出自己的路。',
    description:
      '每一道送到您家門口的菜，背後都凝結著一些SEN青年的專注與汗水。',
    backgroundImage: 'https://shop.deliciousexpress.com.hk/media/story/1783554460206_1783552430945_hero-vegetables-banner_(3).jpg',
    ctaPrimary: { label: '立即選購', url: '#shop' },
    ctaSecondary: { label: '了解我們', url: '/about' },
  },
  {
    type: 'about',
    title: '關於我們',
    description:
      '我們是一家專注為 SEN 青年提供職業訓練及就業轉介工作的社企，致力於培養學員的職場實務技能，強調實踐性及情境化學習模式。\n\n透過我們的職業培訓計劃，我們的目標是創建一個支持和包容的環境，讓這些年輕人能夠茁壯成長，實現自己在事業上的熱情夢想。',
    imageUrl: '/logo-haosong.jpg',
    imageAlt: '好餸社企職業教育暨培訓中心',
  },
  {
    type: 'footer',
    logoUrl: 'https://shop.deliciousexpress.com.hk/media/story/1784358862089_logo-delicious-express.jpg',
    address: '新界葵涌永健路16至20號高威工業中心A座501室',
    phone: '35946130',
    whatsapp: '57961378',
    email: 'support@deliciousexpress.com.hk',
    facebookUrl: 'https://www.facebook.com/deliciousexpress.hk',
    copyright: '© 2026 by 好餸 Delicious Express',
    facebookIcon: '',
  },
];
